import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const BsCustAuth = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const customerId = localStorage.getItem('customer_id');
    if (!customerId) {
      navigate('/');
    } else {
      setIsAuthChecked(true);
    }
  }, [navigate]);

  // Block rendering until auth check is done
  if (!isAuthChecked) {
    return null;
  }

  return children;
};
